import React from 'react';

// Importing icons to match the image
import ArchiveIcon from '@material-ui/icons/Archive';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import WarningIcon from '@material-ui/icons/Warning';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'FG Inventory', value: '28 days', delta: '-4 days opportunity', tone: 'blue', icon: <ArchiveIcon />, deltaTone: 'good' },
    { label: 'Excess Stock', value: '₹42 Cr', delta: 'identified', tone: 'purple', icon: <TrendingUpIcon />, deltaTone: 'warn' },
    { label: 'Shortage Risk', value: '0.31M cases', delta: 'priority markets', tone: 'orange', icon: <WarningIcon />, deltaTone: 'bad' },
    { label: 'Cash Release', value: '₹18 Cr', delta: 'from rebalancing', tone: 'green', icon: <AttachMoneyIcon />, deltaTone: 'good' },
];

const INVENTORY_DATA = [
    { market: 'Maharashtra', cover: '9 days', stock: '665k', plan: '620k', recommended: '700k', delta: '+80k', tone: 'good' },
    { market: 'Karnataka', cover: '10 days', stock: '438k', plan: '410k', recommended: '450k', delta: '+40k', tone: 'good' },
    { market: 'Delhi NCR', cover: '18 days', stock: '390k', plan: '355k', recommended: '335k', delta: '-20k', tone: 'bad' },
    { market: 'West Bengal', cover: '22 days', stock: '345k', plan: '300k', recommended: '270k', delta: '-30k', tone: 'bad' },
    { market: 'Telangana', cover: '8 days', stock: '298k', plan: '285k', recommended: '330k', delta: '+45k', tone: 'good' },
];

const EXCESS_SHORTAGE_BARS = [
    { label: 'FG', percentage: 72, color: '#f59e0b' }, // Orange
    { label: 'Bulk', percentage: 57, color: '#3b82f6' }, // Blue
    { label: 'Glass', percentage: 87, color: '#ef4444' }, // Red
    { label: 'Cartons', percentage: 64, color: '#22c55e' }, // Green
    { label: 'Caps', percentage: 76, color: '#f59e0b' }, // Orange
];

const ACTIONS_DATA = [
    { priority: 'High', action: 'Redeploy East → West', impact: '₹9 Cr' },
    { priority: 'High', action: 'Reduce Core D plan', impact: '₹5 Cr' },
    { priority: 'Med', action: 'Pull forward glass', impact: 'Service' },
    { priority: 'Med', action: 'Use Central stock', impact: '₹4 Cr' },
];

export class Inventory extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Inventory Optimizer</h1>
                        <p>Balance service and working capital across finished goods, bulk, packaging and market inventory.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the image style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: Inventory Position vs Demand Cover */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Inventory Position vs Demand Cover</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Market</th>
                                    <th>Demand Cover</th>
                                    <th>FG Stock</th>
                                    <th>Plan</th>
                                    <th>Recommended</th>
                                    <th>Δ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {INVENTORY_DATA.map((row) => (
                                    <tr key={row.market}>
                                        <td>{row.market}</td>
                                        <td>{row.cover}</td>
                                        <td>{row.stock}</td>
                                        <td>{row.plan}</td>
                                        <td>{row.recommended}</td>
                                        <td className={`cc-delta-${row.tone}`}>{row.delta}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Right Panel: Excess / Shortage Actions */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Excess / Shortage Actions</h2>
                        
                        {/* Horizontal Bar Charts */}
                        <div className="cc-bar-chart-container" style={{marginTop: '20px'}}>
                            {EXCESS_SHORTAGE_BARS.map((bar) => (
                                <div className="cc-bar-row" key={bar.label}>
                                    <div className="cc-bar-label">{bar.label}</div>
                                    <div className="cc-bar-track">
                                        <div 
                                            className="cc-bar-fill" 
                                            style={{ width: `${bar.percentage}%`, backgroundColor: bar.color }}
                                        ></div>
                                    </div>
                                    <div className="cc-bar-percent" style={{ color: bar.color }}>
                                        {bar.percentage}%
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Nested Actions Table */}
                        <table className="cc-actions-table cc-table-striped cc-table-light cc-table-nested">
                            <thead>
                                <tr>
                                    <th>Priority</th>
                                    <th>Action</th>
                                    <th>Impact</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ACTIONS_DATA.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.priority}</td>
                                        <td>{row.action}</td>
                                        <td>{row.impact}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default Inventory;